export function getVisiblePages(totalPages: number, currentPage: number) {
  const visiblePages = []

  // Caso existam menos de 3 páginas, exibe todas
  if (totalPages <= 3) {
    for (let i = 1; i <= totalPages; i++) {
      visiblePages.push(i)
    }
    return visiblePages
  }

  // Se estiver nas primeiras páginas (1, 2 ou 3)
  if (currentPage <= 2) {
    visiblePages.push(1, 2, 3)
  }
  // Se estiver nas páginas intermediárias
  else if (currentPage > 2 && currentPage < totalPages - 1) {
    visiblePages.push(currentPage - 1, currentPage, currentPage + 1)
  }
  // Se estiver nas últimas páginas
  else {
    visiblePages.push(totalPages - 2, totalPages - 1, totalPages)
  }

  return visiblePages
}
